module.exports = __webpack_public_path__ + "img/tang-img3.93ca0531.png";